import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Define a type for the slice state

// Define the initial state using that type

const getEmpWeekoffNTimeshiftSlice = createSlice({
  name: 'Weekoff&TimeShift',

  initialState: { empWeekoffNTimeData: [] },
  reducers: {
    setEmpWeekoffNTimeData: (state: any, action: PayloadAction<any>) => {
      state.empWeekoffNTimeData = action.payload;
    },

    resetEmpWeekoffNTimeData: (state: any) => {
      state = [];
    },
  },
});

export const { setEmpWeekoffNTimeData, resetEmpWeekoffNTimeData } =
  getEmpWeekoffNTimeshiftSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getEmpWeekoffNTimeshiftSlice.reducer;
